// extracted by mini-css-extract-plugin
module.exports = {"title":"HeaderTitle_title__SdhM4"};